import { useBody } from "./body"
import { CardIndicatorProgress } from "../../components/cardIndicatorProgress"

const ActionPlans = () => {
  const { data, loading, getData } = useBody()
  return <CardIndicatorProgress data={data} loading={loading} refresh={getData} title="Planes de acción" />
}

export { ActionPlans }